import { Skeleton } from '@/components/ui/skeleton'

export const AuthorizeFallback = () => (
  <div className="space-y-6">
    <div className="space-y-2">
      <Skeleton className="h-4 w-28 rounded" />
      <div className="grid grid-cols-2 gap-3">
        <Skeleton className="h-28 rounded-lg" />
        <Skeleton className="h-28 rounded-lg" />
      </div>
    </div>
    <div className="space-y-2">
      <Skeleton className="h-4 w-12 rounded" />
      <div className="grid gap-3">
        <Skeleton className="h-16 rounded-lg" />
        <Skeleton className="h-16 rounded-lg" />
        <Skeleton className="h-16 rounded-lg" />
      </div>
    </div>
    <Skeleton className="h-10 w-full rounded-md" />
  </div>
)
